import {parseFeeTag} from '@/screens/Merchants/Fee/updateFeeReducer';
import type {AfriexPromoField, AfriexRatePromo} from '@/types';

import type {TierAction} from './types';
import {TierActionType} from './types';

const updateTierReducer = (state: AfriexRatePromo, action: TierAction) => {
  switch (action.type) {
    case TierActionType.UPDATE_TIER:
      return {
        ...state,
        ...action.payload,
        meta: state.meta ?? {},
      };

    case TierActionType.UPDATE_TAGS: {
      return {
        ...state,
        meta: {
          ...(state.meta ?? {}),
          tags: {
            ...(state?.meta?.tags ?? {}),
            ...(action.payload || {}),
          },
        },
      };
    }

    case TierActionType.REMOVE_TAG: {
      let field: string | undefined;
      if (typeof action.payload === 'string') {
        field = parseFeeTag(action.payload)?.field;
      } else if (action.payload && typeof action.payload === 'object') {
        const {field: payloadField} = action.payload;
        field = payloadField;
      }

      const tags = {...(state?.meta?.tags ?? {})};
      delete tags[field as AfriexPromoField];

      return {
        ...state,
        meta: {
          ...(state.meta ?? {}),
          tags,
        },
      };
    }

    case TierActionType.UPDATE_FLAGS:
      return {
        ...state,
        meta: {
          ...(state.meta ?? {}),
          flags: {
            ...(state?.meta?.flags ?? {}),
            ...action.payload,
          },
        },
      };

    default:
      return state;
  }
};

export default updateTierReducer;
